/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum InternalInventoryDocumentState {
    NEW = 'new',
    WAITING = 'waiting',
    ACCEPTED = 'accepted',
    CONFIRMED = 'confirmed',
    REJECTED = 'rejected',
}
